export const useOwnershipValidation = ownerModel => {
  const sum = ownerModel.reduce((acc, obj) => {
    if (obj.Name && obj.percent) {
      return acc + (parseFloat(obj.percent) || 0);
    }
    return acc;
  }, 0);

  return sum === 100;
};
